<div class="loading-configuration">
  <mat-spinner [diameter]="300" strokeWidth="2"></mat-spinner>
  <div class="logo-container">
    <object type="image/svg+xml" data="assets/purolator-logo-animated.svg"></object>
  </div>
</div>
